import { theme } from '@/styles/theme';

export const styles = {
  container: { width: '100%' },
  list: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    overflowX: 'auto',
    paddingTop: 2,
  },
  hoursList: {
    maxHeight: '200px',
    overflowY: 'auto',
  },
  item: {
    borderRadius: 2,
    border: '1px solid',
    marginBottom: 2,
    cursor: 'pointer',
    minHeight: 80,
    minWidth: 100,
  },
  timeItem: {
    display: 'flex',
    borderRadius: 2,
    border: '1px solid',
    marginBottom: 2,
    cursor: 'pointer',
    marginLeft: '12px',
  },
  timeItemCard: {
    fontSize: '16px',
  },
  listSelectedItem: {
    textAlign: 'center',
    color: theme.palette.primary.main,
  },
  listNotSelectedItem: {
    textAlign: 'center',
  },
  itemFocused: {
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.light,
      borderColor: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  itemNotFocused: {
    borderColor: theme.palette.opaqueGray.main,
  },
  emptyStateDay: {
    fontWeight: 600,
  },
  emptyState: {
    paddingTop: 6,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
  },
  timeTitle: {
    fontSize: '17px',
    fontWeight: 600,
    paddingTop: 4,
    paddingBottom: 4,
  },
  dateMonth: {
    textTransform: 'capitalize',
  },
};
